if ($('.accordion').length > 0) {
	$('[data-role="trigger"]').each(function(index, value) {
	var $item = $(this).parent();

	if($item.find('.accordion__body').length !== 0) {
		$(this).addClass('accordion__arrow');
	}
	});


	$('[data-role="trigger"]').on('click', function(e) {
		e.preventDefault();
		var $trigger = $(e.currentTarget);
		var $item = $trigger.parent();

		if ($item.hasClass('accordion__item')) {
			$item.toggleClass('is-open');
			$item.siblings().removeClass('is-open').find('.accordion__body').slideUp();
			$trigger.next().stop().slideToggle(300);
		}
	});	
}